<template>
	<el-dialog title="消息通知 " :visible.sync="messageBoxShow">
	<div class = "message_box">
		
		
		<div v-for="(item,index) in msgList" :key = "index">
			
			<div class = "msgItem" v-if="item.type=='rob_order'">
				<div style="margin-left: 5vw;margin-right: 2vw;">供应商<a class = "bule_line finger" @click = "checkSuppler(JSON.parse(item.data).supplier)">{{JSON.parse(item.data).supplier.supplierName}}</a>申请了你的<a class = "bule_line finger" @click = "checkOrder(JSON.parse(item.data).order)">订单</a></div>
				
				<div v-if = "JSON.parse(item.data).orderAccept.status=='agree'||JSON.parse(item.data).orderAccept.status=='disagree'">
					<span>{{(JSON.parse(item.data).orderAccept.status=='agree')?'已同意':'已拒绝'}}</span>
				</div>
				<div v-else>
				<el-button @click = "agree(item)">同意</el-button>
				<el-button @click = "disagree(item)">否决</el-button>
				</div>
				<span>{{parseTime(item.createDateTime)}}</span>
			</div>
			<div class = "msgItem" v-if="item.type=='rob_order_result'">
				<span style="margin-left: 5vw;margin-right: 2vw;">企业<a class="bule_line">{{JSON.parse(item.data).order.enterprise.enterpriseName}}</a>{{((JSON.parse(item.data).orderAccept.status)=='agree')?'同意':'拒绝'}}了你的<a class="bule_line finger" @click = "checkOrder(JSON.parse(item.data).order)">订单</a>请求</span>
				<span>{{parseTime(item.createDateTime)}}</span>
			</div>
			
			<div class = "msgItem" v-if="item.type=='order_status'">
				<span style="margin-left: 5vw;margin-right: 2vw;">订单状态变更提示:<a class="bule_line" @click = "checkOrder(JSON.parse(item.data))">订单[{{JSON.parse(item.data).orderNumber}}]</a>{{getDictMapItem('order_status',JSON.parse(item.data).orderStatus).label}}</span>
				<span>{{parseTime(item.createDateTime)}}</span>
			</div>
			
			
		</div>
		
	</div>
	<infoDialog :obj = "info" ref ="infoBox"></infoDialog>
	</el-dialog>
	
	
</template>

<script>
	import infoDialog from '../../common/infoDialog.vue'
	import {update} from '../../../api/mssage.js'
	import {updateOrderAccept} from '../../../api/orderAccept.js'
	import initDict from '@/mixins/initDict'
	import {parseTime} from '../../../utils/index.js'
	export default{
	mixins: [initDict],
		components:{
			infoDialog
		},
		props:{
			
			msgList:Array
			
		},
		created() {
			
			this.$nextTick(()=>{
				
				
				this.getDictMap('order_status')
				
			})
			
		},
		data(){
			
			return {
				messageBoxShow:false,
				info:{}
				
			}
			
		},
		methods:{
			parseTime,
			showSupplier(){
				
				console.log("123");
				
			},
			checkSuppler(o){
				
				this.info = o
				o.yumiEnterpriseUsers = null;
				this.$refs['infoBox'].infoShow = true
			},
			checkOrder(o){
				console.log(o);
				o.enterprise = null;
				o.yumiSupplier = null;
				this.info = o
				this.$refs['infoBox'].infoShow = true
				
			},
			agree(item){
				
				
				
				//修改申请状态//发出新消息
				let orderAccept = JSON.parse(item.data).orderAccept
				orderAccept.status = 'agree'
				updateOrderAccept(orderAccept).then(res=>{
					//修改本条消息状态
					let data = JSON.parse(item.data)
					data.orderAccept = orderAccept
					item.data = JSON.stringify(data)
					
					item.status = 1 //已读
					update(item)
	
				})
				
				
				
				
			},
			disagree(item){
				//修改申请状态//发出新消息
				let orderAccept = JSON.parse(item.data).orderAccept
				orderAccept.status = 'disagree'
				
				updateOrderAccept(orderAccept).then(res=>{
					//修改本条消息状态
					
					let data = JSON.parse(item.data) 
					data.orderAccept = orderAccept
					item.data = JSON.stringify(data)
					
					item.status = 1 //已读
					update(item)
					
				})
				
			}
			
		}
		
		
	}
	
</script>

<style>
	.message_box{
		
		display: flex;
		flex-direction: column;
		align-items: center;
		
	}
	.bule_line{

			color: #337DF7;

	}
	.msgItem{
		
		background-color: #eeeeee;
		width: 50vw;
		min-height: 3vw;
		font-size: 0.8vw;
		display: flex;
		align-items: center;
		justify-content: space-around;
		
	}
</style>
